import React, {useContext, useState, useEffect} from 'react'
import {getWithWarehouseInventories} from "../../../services/serviceStock";
import {Button, Table} from "antd";
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import ReactDragListView from "react-drag-listview";
import OfferUpdateInfo from "./OfferUpdateInfo";
import OfferUpdateTotalStockQuantity from "./OfferUpdateTotalStockQuantity";
import OfferUpdateStock from "./OfferUpdateStock";
import OfferUpdateQuantity from "./OfferUpdateQuantity";
import OfferUpdateUnit from "./OfferUpdateUnit";
import OfferUpdatePrice from "./OfferUpdatePrice";
import OfferUpdateCurrency from "./OfferUpdateCurrency";
import OfferUpdateDiscount from "./OfferUpdateDiscount";
import OfferUpdateDiscount2 from "./OfferUpdateDiscount2";
import OfferUpdateRowTotal from "./OfferUpdateRowTotal";
import OfferUpdateDeadline from "./OfferUpdateDeadline";
import OfferUpdateShippingDate from "./OfferUpdateShippingDate";
import OfferUpdateGift from "./OfferUpdateGift";
import OfferUpdateActions from "./OfferUpdateActions";
import StockCreate from "../../stok/StockCreate";


const OfferUpdateMaterial = () => {
    const {stocks, bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent
    const [stockList, setStockList] = stocks
    const [isStockModalVisible, setIsStockModalVisible] = useState(false)

    useEffect(() => {
        getWithWarehouseInventories()
            .then(({data}) => {
                let stockList = data.map((item) => {
                    let inventoryText = ''
                    let stockQuantity = null

                    item.inventoryList.map(inventory => {
                        stockQuantity += inventory.quantity
                        inventoryText = inventoryText + `${inventory.warehouse.name} - ${inventory.quantity},`
                    })

                    item.stock.quantity = stockQuantity

                    return {
                        text: `${item.stock.code} - ${item.stock.name} ( ${inventoryText} )`,
                        value: item.stock.id,
                        ...item.stock
                    }
                })
                setStockList(stockList)
            })
    }, [])

    const handleAddRow = () => {
        const date = new Date()
        setBidList([
            ...bidList,
            {
                key: date.getTime(),
                amount: 0,
                linePrice: 0,
                discount: 0
            }
        ])
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            const data = [...bidList];
            const item = data.splice(fromIndex - 1, 1)[0];
            data.splice(toIndex - 1, 0, item);
            setBidList(data)
        },
        handleSelector: "a",
    };
    const updateStockContext = ({stockData, inventoryData}) => {
        let inventoryText = ''
        inventoryData.map((stock) => {
            inventoryText = inventoryText + `${stock.warehouse.name} - ${stock.quantity}`
        })

        const stockItem = {
            text: `${stockData.code} - ${stockData.name} ( ${inventoryText} )`,
            value: stockData.id
        }
        setStockList([...stockList, stockItem])
    }
    const toggleStockModal = () => setIsStockModalVisible(!isStockModalVisible)
    const columns = [
        {
            title: '#',
            key: 'rowID',
            render: (t, r, i) => <OfferUpdateInfo record={r} rowCount={i + 1} />
        },
        {
            title: 'Top. Adet',
            key: 'totalQuantity',
            render: (t, r, i) => <OfferUpdateTotalStockQuantity record={r} />
        },
        {
            title: 'Stok Adı',
            key: 'stockName',
            render: (t, r, i) => <OfferUpdateStock rowIndex={i} record={r} />
        },
        {
            title: 'Miktar',
            key: 'quantity',
            render: (t, r, i) => <OfferUpdateQuantity rowIndex={i} record={r}/>
        },
        {
            title: 'Birim',
            key: 'unit',
            render: (t, r, i) => <OfferUpdateUnit record={r} />
        },
        {
            title: 'Birim Fiyatı',
            key: 'price',
            render: (t, r, i) => <OfferUpdatePrice rowIndex={i} record={r} />
        },
        {
            title: 'Para Birimi',
            key: 'priceUnit',
            render: (t, r, i) => <OfferUpdateCurrency rowIndex={i} record={r} />
        },
        {
            title: 'İskonto %',
            key: 'discount',
            render: (t, r, i) => <OfferUpdateDiscount rowIndex={i} record={r} />
        },
        {
            title: 'İskonto 2',
            key: 'discount 2',
            render: (t, r, i) => <OfferUpdateDiscount2 rowIndex={i} record={r} />
        },
        {
            title: 'Toplam',
            key: 'rowTotal',
            render: (t, r, i) => <OfferUpdateRowTotal record={r} />
        },
        {
            title: 'Termin',
            key: 'deadline',
            render: (t, r, i) => <OfferUpdateDeadline rowIndex={i} record={r} />
        },
        {
            title: 'Sevk Tarihi',
            key: 'shippingDeadline',
            render: (t, r, i) => <OfferUpdateShippingDate rowIndex={i} record={r} />
        },
        {
            title: 'Hediye',
            key: 'shippingDeadline',
            render: (t, r, i) => <OfferUpdateGift rowIndex={i} record={r} />
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (t, r, i) => <OfferUpdateActions rowIndex={i} record={r} />
        }
    ]

    return (
        <React.Fragment>
            <Button
                style={{marginBottom: '16px'}}
                type={'link'}
                onClick={() => handleAddRow()}
            >
                Yeni Kalem Ekle
            </Button>
            <Button
                style={{marginBottom: '16px'}}
                type={'link'}
                onClick={toggleStockModal}
            >
                Yeni Stok Ekle
            </Button>
            <ReactDragListView onDragEnd={dragProps.onDragEnd}>
                <Table columns={columns} dataSource={bidList} scroll={{x: 'max-content'}} pagination={false}/>
            </ReactDragListView>
            {
                isStockModalVisible
                    ? <StockCreate show={isStockModalVisible}
                                   modalCloser={toggleStockModal}
                                   updater={updateStockContext}
                                   bubbleResponse={true}
                    />
                    : null
            }
        </React.Fragment>
    )
}
export default OfferUpdateMaterial